import { render, staticRenderFns } from "./OrganizationTalentForm.vue?vue&type=template&id=4a7404df&scoped=true"
import script from "./OrganizationTalentForm.vue?vue&type=script&lang=js"
export * from "./OrganizationTalentForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTalentForm.vue?vue&type=style&index=0&id=4a7404df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7404df",
  null
  
)

export default component.exports